import { Vehicle } from '@spike/vehicle-model';
import Service, {
    Meta,
    BusinessAreaType,
    DaycareService,
    BoardingService,
    TransportationService,
    TrainingService,
    WalkingService
} from '../../model/Service';

// State structure for each business area
export interface BusinessAreaServicesState {
    services: Array<Service>;
    meta: Meta | null;
    loading: boolean;
}

export interface ServicesState {
    // NEW: Segmented state by business area
    servicesByBusinessArea: {
        grooming: BusinessAreaServicesState;
        dental: BusinessAreaServicesState;
        daycare: BusinessAreaServicesState;
        boarding: BusinessAreaServicesState;
        transportation: BusinessAreaServicesState;
        evaluation: BusinessAreaServicesState;
        training: BusinessAreaServicesState;
        walking: BusinessAreaServicesState;
    };
    // MAINTAIN: Global state for compatibility and shared operations
    savedService?: Service;
    evaluationService?: Service | null;
    status: ServicesStatus;
    duplicatedServiceId?: number;
    // NEW: Track current active business area for backwards compatibility
    currentBusinessArea: BusinessAreaType;

    // BACKWARDS COMPATIBILITY: Legacy fields that mirror current business area
    // These are automatically updated by the reducer based on currentBusinessArea
    services: Array<Service>; // Points to servicesByBusinessArea[currentBusinessArea].services
    daycareServices?: Array<DaycareService>;
    boardingServices?: Array<BoardingService>;
    transportationServices?: Array<TransportationService>;
    trainingServices?: Array<TrainingService>;
    walkingServices?: Array<WalkingService>;
    transportationServicesVehicles?: Array<Vehicle>;
    meta: Meta | null; // Points to servicesByBusinessArea[currentBusinessArea].meta
    loading: boolean; // Points to servicesByBusinessArea[currentBusinessArea].loading
}

export enum ServicesStatus {
    Initial,
    Fetching,
    FetchSuccess,
    FetchingEvaluation,
    FetchEvaluationSuccess,
    Saving,
    SaveSuccess,
    SavingBulk,
    SaveBulkSuccess,
    Deleting,
    DeleteSuccess,
    Activating,
    ActivateSuccess,
    PetTypesUpdating,
    PetTypesUpdateSuccess,
    BusinessAreaUpdating,
    BusinessAreaUpdateSuccess,
    StaffUpdating,
    StaffUpdateSuccess,
    Inactivating,
    InactivateSuccess,
    FetchingDaycareServices,
    FetchDaycareServicesSuccess,
    FetchingBoardingServices,
    FetchBoardingServicesSuccess,
    FetchingTransportationServices,
    FetchTransportationServicesSuccess,
    FetchingTransportationServicesVehicles,
    FetchTransportationServicesVehiclesSuccess,
    FetchingTrainingServices,
    FetchTrainingServicesSuccess,
    FetchingWalkingServices,
    FetchWalkingServicesSuccess,
    FetchingBoardingOffers,
    FetchBoardingOffersSuccess,
    Error
}
